module.exports = __webpack_public_path__ + "assets/images/10HX.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10HX.png
// module id = 1283
// module chunks = 1